import {
  Config,
  setApiGatewayUrl,
  setMediaServiceUrl,
  setDocumentsUrl,
  setGoogleMapsKey,
  setMiddlewareUrl,
} from "./configuration";

const initialize = ({
  apiGatewayUrl,
  mediaServiceUrl,
  documentsUrl,
  googleMapsKey,
  middlewareUrl,
}: {
  apiGatewayUrl?: Config["apiGatewayUrl"];
  mediaServiceUrl?: Config["mediaServiceUrl"];
  documentsUrl?: Config["documentsUrl"];
  googleMapsKey?: Config["googleMapsKey"];
  middlewareUrl?: Config["middlewareUrl"];
}) => {
  apiGatewayUrl && setApiGatewayUrl(apiGatewayUrl);
  mediaServiceUrl && setMediaServiceUrl(mediaServiceUrl);
  documentsUrl && setDocumentsUrl(documentsUrl);
  googleMapsKey && setGoogleMapsKey(googleMapsKey);
  middlewareUrl && setMiddlewareUrl(middlewareUrl);
};

export default initialize;
